import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SvgIconModule } from '../svg-icon';
import { ClipboardModule } from 'ngx-clipboard';
import { InputFieldComponent } from './input-field.component';

@NgModule({
    declarations: [
        InputFieldComponent,
    ],
    exports: [
        InputFieldComponent,

    ],
    imports: [
        CommonModule,
        FormsModule,
        SvgIconModule,
        ClipboardModule
    ]
})
export class InputFieldModule { }
